"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kebabCase = void 0;
const words_1 = require("./words");
function kebabCase(str) {
    return (0, words_1.words)(str).join('-');
}
exports.kebabCase = kebabCase;
